import { useLocation, useNavigate } from "react-router-dom";
import {
  ClinicianList,
  ConsultationCodeType,
  initialFormData,
  MasterFormDataType,
  MasterTableDataType,
  TimeSlotType,
} from "./types";
import usePopup from "../../../hooks/usePopup";
import { useMutation, useQuery } from "react-query";
import {
  getAllClinician,
  getAllConsultations,
  getDoctorLicense,
  getTimeSlots,
  saveMasterData,
} from "./services";
import { Controller, useForm } from "react-hook-form";
import { ChangeEvent, useContext, useEffect, useState } from "react";
import {
  Avatar,
  Badge,
  BadgeProps,
  Button,
  CircularProgress,
  Divider,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  styled,
  Typography,
} from "@mui/material";
import { CustomFormField } from "../../../utilis/component/CustomFormElement";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import debounce from "../../../utilis/methods/networkHandling";
import { getAllDepattment } from "../../../PatientCare/PatientBooking/v1/services";
import { DepartmentTypes } from "../../../PatientCare/PatientBooking/v1/types";
import DoneIcon from "@mui/icons-material/Done";
import AddIcon from "@mui/icons-material/Add";
import MoreTimeIcon from "@mui/icons-material/MoreTime";
import DoctorMasterDataProvider, {
  DoctorMasterDataContext,
} from "./context/DoctorMasterDataProvider";
import DoctorLicense from "./DoctorLicense";
import TimeSlotes from "./TimeSlotes";
import { FormOnChangeEventType } from "../../../EMR/types";
const StyledBadge = styled(Badge)<BadgeProps>(({ theme }) => ({
  "& .MuiBadge-badge": {
    width: 6,
    Height: 6,
    border: `2px solid ${theme.palette.background.paper}`,
    padding: "0 4px",
  },
}));
// const base = (window as any)._env_?.BASE_URL;
const pageTitle = "Doctors";
const AddOrEdit = () => {
  const navigate = useNavigate();
  const { control, handleSubmit, reset, setValue } =
    useForm<MasterFormDataType>({
      defaultValues: initialFormData,
    });
  const [openLicense, setOpenLicense] = useState<boolean>(false);
  const [openTime, setOpenTime] = useState<boolean>(false);
  const [files, setFiles] = useState({
    sign: "",
    seal: "",
    photo: "",
  });
  const { licenseList, setLicenseList, setTimeSlots, timeSlots } = useContext(
    DoctorMasterDataContext
  );
  const {
    state: { data = null },
  } = useLocation() as { state: { data: MasterTableDataType } };
  const { showSnackbar, CustomModal } = usePopup();
  const handleGoBack = () => {
    navigate(-1);
  };

  useQuery(
    ["allDoctorTimeSlot", data?.id],
    async () => await getTimeSlots(data?.id as number),
    {
      enabled: Boolean(data?.id),
      refetchOnWindowFocus: false,
      onSuccess: (result) => {
        if (result?.response?.items?.length) {
          const update: { [key: number]: TimeSlotType } = {};
          result?.response?.items.forEach((day) => {
            update[day.dayId] = day;
          });
          setTimeSlots(update);
        }
      },
    }
  );

  const { isLoading: licenseLoading } = useQuery(
    ["allDoctorLicense"],
    async () => await getDoctorLicense(data?.id as number),
    {
      enabled: Boolean(data?.id),
      refetchOnWindowFocus: false,
      onSuccess: (result) => {
        if (result.responseIndicator == "success") {
          setLicenseList(result?.response || []);
        }
      },
    }
  );

  const {
    mutate: fetchAllDepattment,
    data: department,
    isLoading: departmentLoading,
  } = useMutation(getAllDepattment);

  const {
    mutate: getConsultationCodes,
    data: consultationCodes,
    isLoading: consultationLoading,
  } = useMutation(getAllConsultations);
  const { data: clinicians, isLoading: clinicianLoading } = useQuery(
    ["allClinicianList"],
    getAllClinician,
    {
      refetchOnWindowFocus: false,
    }
  );

  const { mutate: save, isLoading } = useMutation(saveMasterData, {
    onSuccess: (result) => {
      if (result.responseIndicator == "success") {
        showSnackbar({
          message: result.responseMessage,
          open: true,
          variant: "success",
          duration: 3000,
        });
        handleGoBack();
      } else {
        showSnackbar({
          message: result.responseMessage,
          open: true,
          variant: "warning",
          duration: 3000,
        });
      }
    },
    onError: (e: any) => {
      showSnackbar({
        message:
          e?.response?.data?.errorMessage ||
          e?.response?.data?.responseMessage ||
          "Something went wrong !",
        open: true,
        variant: "error",
        duration: 3000,
      });
    },
  });
  const onSubmit = (value: MasterFormDataType) => {
    if (Boolean(licenseList.length)) {
      save({
        doctorDetails: {
          ccep: value?.ccep,
          clcn_id: value?.clinician?.clcn_id || 0,
          code: value?.code,
          color: value?.color,
          consultationCodeId: Number(value?.consultationCode?.cptId || 0),
          consultationFee: String(value?.consultationFee || 0),
          createdDate: "",
          dept_id: Number(value?.department?.departmentId),
          durationForPatient: Number(value.duration?.value || 0),
          followUpCodeId: Number(value.followUpCode?.cptId || 0),
          followUpFee: String(value.followUpFee || ""),
          id: Number(data?.id || 0),
          ip: "",
          photo: value.photo?.name || "",
          postOfficePassword: value.password,
          postOfficeUsername: value.userName,
          roomNo: value?.roomNumber || "",
          seal: value?.seal?.name || "",
          sign: value?.sign?.name || "",
          status: value.status,
          tokenPrefix: value.tokenPrefix,
        },
        license: licenseList,
        photo: value?.photo || null,
        seal: value.seal || null,
        sign: value?.sign || null,
      });
    } else
      [
        showSnackbar({
          message: "Please add doctor license",
          open: true,
          variant: "warning",
          duration: 3000,
        }),
      ];
  };

  const handleSearch = (e: ChangeEvent<HTMLInputElement>) => {
    getConsultationCodes({ groupId: 3, search: e.target.value });
  };

  const debounceSearch = debounce(handleSearch, 500);

  const handleReset = () => {
    reset(initialFormData);
  };

  const handleNavigateTimeClick = () => {
    setOpenTime(true);
  };

  const goToLicenseEdit = () => {
    setOpenLicense(true);
  };

  const onClinicianChange = (e: FormOnChangeEventType) => {
    const { value } = e.target;
    setValue("name", value.clcn_name);
  };

  const showFiles = (file: File | null, key: keyof typeof files) => {
    const fileUrl = file ? URL.createObjectURL(file) : "";
    console.log(fileUrl);
    setFiles((prev) => ({
      ...prev,
      [key]: fileUrl,
    }));
  };

  useEffect(() => {
    getConsultationCodes({ search: "", groupId: 3 });
    fetchAllDepattment();
    if (data) {
      const duration =
        timeSlotes.find((item) => item.value == data.durationForPatient) ||
        initialFormData.duration;
      reset({
        ccep: data.ccep,
        code: data?.code,
        consultationFee: data?.consultationFee,
        followUpFee: data.followUpFee,
        color: data?.color || initialFormData.color,
        roomNumber: data.roomNo,
        name: data.name,
        password: data.postOfficePassword,
        userName: data.postOfficeUsername,
        consultationCode: {
          cptCode: data.consultationCode,
          cptId: data.consultationCodeId,
        },
        followUpCode: {
          cptCode: data.followUpCode,
          cptId: data.followUpCodeId,
        },
        clinician: {
          clcn_id: data.clinicianId,
          clcn_code: data.licenceNumber,
          clcn_name: data.name,
        },
        department: {
          departmentName: data.deptName,
          departmentId: data.deptId,
        },
        tokenPrefix: data.tokenPrefix,
        status: data.status,
        photo: null,
        seal: null,
        sign: null,
        duration,
      });
      setFiles({
        photo: data?.photo || "",
        sign: data?.sign || "",
        seal: data?.seal || "",
      });
      console.log({
        photo: data?.photo || "",
        sign: data?.sign || "",
        seal: data?.seal || "",
      });
    }
  }, [data]);

  return (
    <div className="p-3">
      <CustomModal
        title="Doctor License"
        open={openLicense}
        setOpen={setOpenLicense}
      >
        <div className="w-[70vw]">
          <DoctorLicense />
        </div>
      </CustomModal>
      <CustomModal title="Time slot" open={openTime} setOpen={setOpenTime}>
        <div className="w-[80vw]">
          <TimeSlotes />
        </div>
      </CustomModal>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Paper>
          <div className="flex justify-between items-center p-2">
            <div>
              <Typography variant="h6" className="p-3">
                {data ? "Update" : "Add"} {pageTitle}
              </Typography>
            </div>
            <div className="flex gap-2">
              <Button
                disabled={isLoading}
                variant="outlined"
                startIcon={<ArrowBackIcon />}
                onClick={handleGoBack}
              >
                back
              </Button>

              {!Boolean(data) && (
                <Button
                  disabled={isLoading}
                  color="error"
                  type="reset"
                  onClick={handleReset}
                  startIcon={<CloseIcon />}
                >
                  reset
                </Button>
              )}

              <Button
                disabled={isLoading}
                type="submit"
                color="success"
                startIcon={
                  isLoading ? (
                    <CircularProgress size={20} color="success" />
                  ) : (
                    <SaveIcon />
                  )
                }
              >
                {data ? "update" : "save"}
              </Button>
            </div>
          </div>
          <Divider />
          <div className="p-3 grid grid-cols-4 gap-3">
            <div className="col-span-full flex justify-end gap-2">
             {Boolean(data?.id ) && <StyledBadge
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                badgeContent={
                  Boolean(
                    Object.entries(timeSlots).length || data?.isTimeSlot == 1
                  ) ? (
                    <DoneIcon sx={{ fontSize: "10px" }} />
                  ) : (
                    0
                  )
                }
                color="primary"
              >
                <Button
                  variant={
                    Boolean(
                      Object.entries(timeSlots).length || data?.isTimeSlot == 1
                    )
                      ? "contained"
                      : "outlined"
                  }
                  color="info"
                  onClick={handleNavigateTimeClick}
                  endIcon={<MoreTimeIcon />}
                >
                  time slot
                </Button>
              </StyledBadge>}

              <StyledBadge
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                badgeContent={
                  Boolean(licenseList.length || data?.isLicence == 1) ? (
                    <DoneIcon sx={{ fontSize: "10px" }} />
                  ) : (
                    0
                  )
                }
                color="primary"
              >
                <Button
                  disabled={licenseLoading}
                  variant={
                    Boolean(licenseList.length || data?.isLicence == 1)
                      ? "contained"
                      : "outlined"
                  }
                  color="info"
                  onClick={goToLicenseEdit}
                  endIcon={<AddIcon />}
                >
                  license
                </Button>
              </StyledBadge>
            </div>
            <CustomFormField
              control={control}
              name="code"
              element="input"
              fieldProps={{ label: "Enter doctor code " }}
              rules={{ required: "Required" }}
            />
            <CustomFormField
              control={control}
              name="clinician"
              element="autocomplete"
              fieldProps={{
                label: "Select doctor from clinician list ",
                onChange: debounceSearch,
              }}
              rules={{ required: "Required", onChange: onClinicianChange }}
              options={clinicians?.response || []}
              loading={clinicianLoading}
              autocompleteProps={{
                getOptionLabel: (option: ClinicianList) => option.clcn_code,
                filterOptions: (option) => option,
                renderOption: (params, option: ClinicianList) => (
                  <ListItem {...params}>
                    <ListItemText primary={option.clcn_name} />
                  </ListItem>
                ),
              }}
            />
            <CustomFormField
              control={control}
              name="consultationCode"
              element="autocomplete"
              fieldProps={{
                label: "Select consultation code ",
                onChange: debounceSearch,
              }}
              rules={{ required: "Required" }}
              options={consultationCodes?.response || []}
              loading={consultationLoading}
              autocompleteProps={{
                getOptionLabel: (option: ConsultationCodeType) =>
                  option.cptCode,
                renderOption: (params, option: ConsultationCodeType) => (
                  <ListItem {...params}>
                    <ListItemIcon>{option.cptCode}</ListItemIcon>
                    <ListItemText primary={`| ${option.cptName}`} />
                  </ListItem>
                ),
                filterOptions: (option) => option,
              }}
            />
            <CustomFormField
              control={control}
              name="name"
              element="input"
              fieldProps={{ label: "Name " }}
              rules={{ required: "Required" }}
            />
            <CustomFormField
              control={control}
              name="followUpCode"
              element="autocomplete"
              fieldProps={{ label: "Follow up code " }}
              rules={{ required: "Required" }}
              options={consultationCodes?.response || []}
              loading={consultationLoading}
              autocompleteProps={{
                getOptionLabel: (option: ConsultationCodeType) =>
                  option.cptCode,
                renderOption: (params, option: ConsultationCodeType) => (
                  <ListItem {...params}>
                    <ListItemIcon>{option.cptCode}</ListItemIcon>
                    <ListItemText primary={`| ${option.cptName}`} />
                  </ListItem>
                ),
                filterOptions: (option) => option,
              }}
            />
            <CustomFormField
              control={control}
              name="ccep"
              element="input"
              fieldProps={{ label: "Enter CCEP " }}
              rules={{ required: "Required" }}
            />
            <CustomFormField
              control={control}
              name="consultationFee"
              element="input"
              fieldProps={{ label: "Enter consultation fee " }}
              rules={{ required: "Required" }}
            />
            <CustomFormField
              control={control}
              name="followUpFee"
              element="input"
              fieldProps={{ label: "Enter follow up fee " }}
              rules={{ required: "Required" }}
            />
            <CustomFormField
              control={control}
              name="department"
              element="autocomplete"
              fieldProps={{ label: "Enter department " }}
              rules={{ required: "Required" }}
              options={department?.response || []}
              loading={departmentLoading}
              autocompleteProps={{
                getOptionLabel: (option: DepartmentTypes) =>
                  option.departmentName,
                filterOptions: (option) => option,
              }}
            />
            <CustomFormField
              control={control}
              name="roomNumber"
              element="input"
              fieldProps={{ label: "Room number " }}
              rules={{ required: false }}
            />
            <CustomFormField
              control={control}
              name="tokenPrefix"
              element="input"
              fieldProps={{ label: "Enter token prefix " }}
              rules={{ required: "Required" }}
            />
            {/* <input type="color" /> */}
            <CustomFormField
              control={control}
              name="color"
              element="input"
              fieldProps={{ label: "Color ", type: "color" }}
              rules={{ required: false }}
            />
            <CustomFormField
              control={control}
              name="userName"
              element="input"
              fieldProps={{ label: "Enter username " }}
              rules={{ required: "Required" }}
            />
            <CustomFormField
              control={control}
              name="password"
              element="input"
              fieldProps={{ label: "Enter password ", type: "password" }}
              rules={{ required: "Required" }}
            />
            <CustomFormField
              control={control}
              name="duration"
              element="autocomplete"
              fieldProps={{ label: "Choose duration " }}
              rules={{ required: "Required" }}
              options={timeSlotes}
              loading={clinicianLoading}
              autocompleteProps={{
                getOptionLabel: (option) => option.label,
              }}
            />

            <CustomFormField
              control={control}
              name="status"
              element="radio"
              radioProps={{ row: true }}
              radios={[
                { label: "Active", value: 1 },
                { label: "Inactive", value: 0 },
              ]}
              fieldProps={{ label: "Status " }}
              rules={{ required: "Required" }}
            />

            <div className="col-span-full grid grid-cols-3 gap-2">
              <label className="flex gap-2 items-center cursor-pointer">
                Select sign
                <div>
                  <Avatar
                    variant="rounded"
                    src={files.sign}
                    sx={{ width: 60, height: 60, objectFit: "cover" }}
                  />
                  <Controller
                    name="sign"
                    control={control}
                    defaultValue={null}
                    render={({ field }) => (
                      <input
                        className="hidden"
                        accept=".jpg,.jpeg,.png"
                        type="file"
                        onChange={(e) => {
                          field.onChange(e.target.files && e.target.files[0]);
                          showFiles(
                            e.target.files ? e.target.files[0] : null,
                            "sign"
                          );
                        }}
                        // Note: field.value is an array (FileList), but we can't set it manually
                      />
                    )}
                  />
                </div>
              </label>

              <label className="flex gap-2 items-center cursor-pointer">
                Select seal
                <div>
                  <Avatar
                    variant="rounded"
                    src={files.seal}
                    sx={{ width: 60, height: 60, objectFit: "cover" }}
                  />
                  <Controller
                    name="seal"
                    control={control}
                    defaultValue={null}
                    render={({ field }) => (
                      <input
                        className="hidden"
                        accept=".jpg,.jpeg,.png"
                        type="file"
                        onChange={(e) => {
                          field.onChange(e.target.files && e.target.files[0]);
                          showFiles(
                            e.target.files ? e.target.files[0] : null,
                            "seal"
                          );
                        }}
                        // Note: field.value is an array (FileList), but we can't set it manually
                      />
                    )}
                  />
                </div>
              </label>

              <label className="flex gap-2 items-center cursor-pointer">
                Select photo
                <div>
                  <Avatar
                    variant="rounded"
                    src={files.photo}
                    sx={{ width: 60, height: 60, objectFit: "cover" }}
                  />
                  <Controller
                    name="photo"
                    control={control}
                    defaultValue={null}
                    render={({ field }) => (
                      <input
                        className="hidden"
                        accept=".jpg,.jpeg,.png"
                        type="file"
                        onChange={(e) => {
                          field.onChange(e.target.files && e.target.files[0]);
                          showFiles(
                            e.target.files ? e.target.files[0] : null,
                            "photo"
                          );
                        }}
                        // Note: field.value is an array (FileList), but we can't set it manually
                      />
                    )}
                  />
                </div>
              </label>
            </div>
          </div>
        </Paper>
      </form>
    </div>
  );
};

const DoctorAddOrEdit = () => {
  return (
    <DoctorMasterDataProvider>
      <AddOrEdit />
    </DoctorMasterDataProvider>
  );
};

export default DoctorAddOrEdit;

const timeSlotes = [
  {
    value: 60,
    label: "1 Minute",
  },
  {
    value: 30,
    label: "2 Minutes",
  },
  {
    value: 20,
    label: "3 Minutes",
  },
  {
    value: 15,
    label: "4 Minutes",
  },
  {
    value: 12,
    label: "5 Minutes",
  },
  {
    value: 10,
    label: "6 Minutes",
  },
  {
    value: 6,
    label: "10 Minutes",
  },
  {
    value: 5,
    label: "12 Minutes",
  },
  {
    value: 4,
    label: "15 Minutes",
  },
  {
    value: 3,
    label: "20 Minutes",
  },
  {
    value: 2,
    label: "30 Minutes",
  },
  {
    value: 1,
    label: "60 Minutes",
  },
];
